(function(){
  var d=document, root=d.documentElement; root.classList.remove('no-js');
  var mk=function(t){return{get:function(k){try{return window[t].getItem(k)}catch(e){return null}},set:function(k,v){try{window[t].setItem(k,v)}catch(e){}},remove:function(k){try{window[t].removeItem(k)}catch(e){}}}};var LS=mk('local'+'Storage'),SS=mk('session'+'Storage');
  var DROP=new Date('2026-12-07T19:00:00-06:00').getTime();

  /* ---------- Countdown ---------- */
  var el=d.querySelector('.g-count'), shorts=d.querySelectorAll('[data-count-short]');
  if(el && el.getAttribute('data-drop')) DROP=new Date(el.getAttribute('data-drop')).getTime();
  var pad=function(n){return String(n).padStart(2,'0')};
  (function tick(){
    var diff=Math.max(0,DROP-Date.now()), s=Math.floor(diff/1000);
    var dd=Math.floor(s/86400), hh=Math.floor(s%86400/3600), mm=Math.floor(s%3600/60);
    shorts.forEach(function(x){x.textContent= diff? (dd+'d '+pad(hh)+'h '+pad(mm)+'m') : 'Live now'});
    if(el){
      if(diff===0){el.classList.add('is-live');var lt=el.getAttribute('data-live')||'EUDÆMONIA is live',ls=el.getAttribute('data-live-sub')||'Welcome to the Garden';el.innerHTML='<div style="grid-column:1/-1"><span></span><small></small></div>';el.querySelector('span').textContent=lt;el.querySelector('small').textContent=ls;return}
      var u=function(k){return el.querySelector('[data-u="'+k+'"]')};
      u('d').textContent=dd;u('h').textContent=pad(hh);u('m').textContent=pad(mm);u('s').textContent=pad(s%60);
    }
    setTimeout(tick,1000);
  })();

  /* ---------- Reveal on scroll ---------- */
  var items=d.querySelectorAll('.g-reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.15,rootMargin:'0px 0px -40px 0px'});
    items.forEach(function(i){io.observe(i)});
  } else items.forEach(function(i){i.classList.add('is-in')});

  /* ---------- Traffic source → customer tag (src-instagram, src-tiktok …) ---------- */
  var q=new URLSearchParams(location.search);
  var src=(q.get('utm_source')||q.get('ref')||q.get('src')||'').toLowerCase().replace(/[^a-z0-9_-]/g,'').slice(0,24);
  if(src) SS.set('g-src',src);
  src=src||SS.get('g-src')||'';
  if(!src && d.referrer){var r=d.referrer;src=/instagram/.test(r)?'instagram':/tiktok/.test(r)?'tiktok':/google\./.test(r)?'google':/facebook|fb\./.test(r)?'facebook':''}
  if(src) d.querySelectorAll('input[name="contact[tags]"]').forEach(function(t){t.value+=', src-'+src});
  ['utm_medium','utm_campaign'].forEach(function(key){
    var value=(q.get(key)||SS.get('g-'+key)||'').toLowerCase().replace(/[^a-z0-9_-]/g,'').slice(0,48);
    if(!value) return;
    SS.set('g-'+key,value);
    d.querySelectorAll('input[name="contact[tags]"]').forEach(function(t){t.value+=', '+key.replace('_','-')+'-'+value});
  });

  /* ---------- Joined state ---------- */
  var tpl=d.getElementById('g-joined-tpl');
  function ics(){
    var body=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//GAGGIO//EUDAEMONIA//EN','BEGIN:VEVENT','UID:eudaemonia@gaggio.shop','DTSTAMP:20261001T000000Z','DTSTART:20261208T010000Z','DTEND:20261208T020000Z','SUMMARY:GAGGIO — EUDÆMONIA','DESCRIPTION:EUDÆMONIA opens at 7PM CST. Change into your constant best.','URL:https://gaggio.shop','BEGIN:VALARM','TRIGGER:-PT15M','ACTION:DISPLAY','DESCRIPTION:EUDÆMONIA opens in 15 minutes','END:VALARM','END:VEVENT','END:VCALENDAR'].join('\r\n');
    var a=d.createElement('a');a.href=URL.createObjectURL(new Blob([body],{type:'text/calendar'}));a.download='GAGGIO-EUDAEMONIA.ics';d.body.appendChild(a);a.click();a.remove();
  }
  function share(btn){
    var data={title:'GAGGIO — EUDÆMONIA',text:'EUDÆMONIA · 7 December · 7PM CST. Enter the Garden:',url:location.origin+location.pathname+'?utm_source=friend'};
    if(navigator.share){navigator.share(data).catch(function(){})}
    else if(navigator.clipboard){navigator.clipboard.writeText(data.url).then(function(){btn.textContent='Link copied'})}
  }
  function showJoined(cap){
    if(!tpl||!cap||cap.querySelector('.g-joined')) return;
    var n=tpl.content.firstElementChild.cloneNode(true);
    if(Date.now()>=DROP && (+LS.get('g-requested-at')||Date.now())>=DROP){
      n.querySelector('.g-joined__title').textContent='Request received.';
      n.querySelector('.g-joined__body').textContent='The offer waitlist is closed. If asked, confirm your email to receive future release updates.';
      n.querySelector('.g-joined__actions').remove();
      cap.innerHTML='';cap.appendChild(n);return;
    }
    n.querySelector('[data-ics]').addEventListener('click',ics);
    var sb=n.querySelector('[data-share]'); sb.addEventListener('click',function(){share(sb)});
    cap.innerHTML='';cap.appendChild(n);
  }
  function markJoined(focusCap){
    LS.set('g-requested-at',String(Date.now())); root.classList.add('is-joined');
    d.querySelectorAll('[data-capture]').forEach(function(c){showJoined(c)});
    if(focusCap){var j=focusCap.querySelector('.g-joined');j&&j.focus({preventScroll:true})}
    if(!SS.get('g-form-accepted-tracked')){
      try{
        if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish){
          Shopify.analytics.publish('gaggio_waitlist_form_accepted',{
            source:src||'direct',
            medium:SS.get('g-utm_medium')||'',
            campaign:SS.get('g-utm_campaign')||'',
            offer_waitlist_open:Date.now()<DROP
          });
          SS.set('g-form-accepted-tracked','1');
        }
      }catch(e){}
    }
  }
  var pendingAt=+SS.get('g-submit-pending-at')||0;
  var posted=!!d.querySelector('[data-signup-accepted]')&&pendingAt>0&&Date.now()-pendingAt>=0&&Date.now()-pendingAt<900000;
  if(posted) SS.remove('g-submit-pending-at');
  if(posted){markJoined(d.querySelector('[data-capture]'))}
  else if(LS.get('g-requested-at')) {root.classList.add('is-joined'); d.querySelectorAll('[data-capture]').forEach(function(c){showJoined(c)})}

  /* ---------- Forms ---------- */
  var EMAIL=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  d.querySelectorAll('[data-capture] form').forEach(function(f){
    f.addEventListener('submit',function(e){
      var cap=f.closest('[data-capture]'), msg=cap&&cap.querySelector('.g-form__msg');
      var v=f.querySelector('input[type=email]').value.trim();
      if(!EMAIL.test(v)){e.preventDefault();if(msg){msg.textContent='Please enter a valid email address.';msg.classList.add('g-form__msg--error')}return}
      f.classList.add('is-sending'); f.querySelector('button[type=submit]').setAttribute('aria-busy','true');
      if(!f.hasAttribute('action')){e.preventDefault();f.classList.remove('is-sending');f.querySelector('button[type=submit]').removeAttribute('aria-busy');if(msg)msg.textContent='The form is unavailable. Please reload and try again.';}
      else SS.set('g-submit-pending-at',String(Date.now()));
    });
  });

  /* ---------- Sticky bar ---------- */
  var sticky=d.querySelector('[data-sticky]'), hero=d.querySelector('.g-hero'), garden=d.getElementById('garden');
  if(sticky&&hero&&'IntersectionObserver' in window){
    var heroOut=false, gardenIn=false;
    var upd=function(){var on=heroOut&&!gardenIn&&!root.classList.contains('is-joined');sticky.classList.toggle('is-on',on);sticky.setAttribute('aria-hidden',on?'false':'true');sticky.querySelector('a').tabIndex=on?0:-1};
    new IntersectionObserver(function(es){heroOut=!es[0].isIntersecting;upd()},{threshold:0.05}).observe(hero);
    garden&&new IntersectionObserver(function(es){gardenIn=es[0].isIntersecting;upd()},{threshold:0.1}).observe(garden);
  }

  /* ---------- Garden invitation (once every 3 days, never after joining) ---------- */
  var modal=d.querySelector('[data-modal]');
  if(modal&&typeof modal.showModal==='function'){
    var seen=+LS.get('g-modal-seen')||0, okTime=Date.now()-seen>3*864e5, opened=false, privacyRetry=null;
    var open=function(){
      if(opened||!okTime||!modal.isConnected||root.classList.contains('is-joined')||root.classList.contains('g-closed')||posted)return;
      var privacy=d.querySelector('#shopify-pc__banner');
      if(privacy&&privacy.getClientRects().length&&getComputedStyle(privacy).visibility!=='hidden'){
        if(!privacyRetry)privacyRetry=setTimeout(function(){privacyRetry=null;open()},1000);
        return;
      }
      opened=true;LS.set('g-modal-seen',String(Date.now()));modal.showModal();
    };
    modal.querySelectorAll('[data-close]').forEach(function(b){b.addEventListener('click',function(){modal.close()})});
    modal.addEventListener('click',function(e){if(e.target===modal)modal.close()});
    var t0=Date.now();
    setTimeout(open,6000);
    if(matchMedia('(pointer:fine)').matches) d.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<8&&Date.now()-t0>6000)open()});
  }
})();
/* Keep "G.g" as written (Cinzel + uppercase labels would turn it into G.G) */
(function(){
  function wrap(root){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){return n.nodeValue.indexOf('G.g')>-1&&!(n.parentNode&&n.parentNode.classList&&n.parentNode.classList.contains('g-gg'))&&!/^(SCRIPT|STYLE|TEXTAREA|TITLE)$/.test(n.parentNode.nodeName)?1:3}});
    var list=[],n;while((n=w.nextNode()))list.push(n);
    list.forEach(function(t){var parts=t.nodeValue.split('G.g'),f=document.createDocumentFragment();parts.forEach(function(p,i){if(i){var s=document.createElement('span');s.className='g-gg';s.textContent='G.g';f.appendChild(s)}f.appendChild(document.createTextNode(p))});t.parentNode.replaceChild(f,t)});
  }
  wrap(document.body);
  new MutationObserver(function(ms){ms.forEach(function(m){m.addedNodes.forEach(function(x){if(x.nodeType===1)wrap(x)})})}).observe(document.body,{childList:true,subtree:true});
})();

/* Image protection: discourages saving (right-click, drag, long-press). No website can block screenshots. */
(function(){
  var r=document.documentElement; if(!r.classList.contains('g-protected')) return;
  var isImg=function(t){return t&&(t.tagName==='IMG'||t.tagName==='PICTURE'||(t.closest&&t.closest('.g-hero,.g-modal__art,.g-constance__art,.g-philo__grid h3,.g-logo,.g-footer__top,.g-garden__mark')))};
  document.addEventListener('contextmenu',function(e){if(isImg(e.target))e.preventDefault()},{capture:true});
  document.addEventListener('dragstart',function(e){if(e.target&&e.target.tagName==='IMG')e.preventDefault()},{capture:true});
})();

/* Waitlist closes at the drop: after 7 Dec 7PM CT, new sign-ups join the newsletter only (no garden-member tag), offer messaging hides, pop-up stops. */
(function(){
  var d=document, r=d.documentElement, el=d.querySelector('.g-count');
  var drop=new Date((el&&el.getAttribute('data-drop'))||'2026-12-07T19:00:00-06:00').getTime();
  function close(){
    r.classList.add('g-closed');
    d.querySelectorAll('input[name="contact[tags]"]').forEach(function(t){t.value=t.value.split(',').map(function(s){return s.trim()}).filter(function(s){return s&&s!=='garden-member'}).concat(['after-drop']).join(', ')});
    var m=d.querySelector('[data-modal]'); if(m&&m.open) m.close(); if(m) m.remove();
    d.querySelectorAll('[data-capture] form button[type=submit]').forEach(function(b){b.textContent='Get release news'});
    var headerLink=d.querySelector('.g-header a.g-btn');if(headerLink)headerLink.textContent='Get release news';
  }
  function scheduleClose(){
    var remaining=drop-Date.now();
    if(remaining<=0) close();
    else setTimeout(scheduleClose,Math.min(remaining,2147483000));
  }
  scheduleClose();
})();
